<template>
  <div>
      <div class="md-layout">
        <h4 class="md-layout-item md-size-100" style="text-align: left">Empfangen</h4>
        <br />
        <div v-for="badge in my" :key="badge.id" class="md-layout-item md-medium-size-33 md-small-size-50 md-size-33">
          <div @click="onReceivedBadgeClicked(badge)" class="badge">
            <div class="icon">
              <img :src="badge.icon" />
            </div>
            <p>{{ badge.name }}</p>
          </div>
      </div>
      <modal :id="receivedBadge._id" v-show="showReceivedModal">
            <template slot="header">
              <span class="h3">Auszeichung</span>
            </template>
            <template slot="body">
              <div class="modal-content">
                <div class="received-modal-icon">
                  <img :src="receivedBadge.icon" />
                </div>
                <h2 class="title">{{ receivedBadge.name }}</h2>
                <h3 class="h5" v-if="receivedBadge.subtitle">{{ receivedBadge.subtitle }}</h3>
                <p>{{ receivedBadge.points}} Punkte - {{ receivedBadge.challenge || receivedBadge.description }}</p>
                <p v-if="receivedBadge.challenge && receivedBadge.description">{{ receivedBadge.description }}</p>
                <blockquote v-if="receivedBadge.explanation">
                  <p>Erklärung: {{ receivedBadge.explanation }}</p>
                </blockquote>
                <p slot="date" class="date" v-if="receivedBadge.activeFrom">
                  {{ formatDate(receivedBadge.activeFrom) }} bis {{ formatDate(receivedBadge.activeUntil) }}
                </p>
                <div v-if="receivedBadge.activeFrom" class="limited-tag">
                  <h6 class="limited-text">BEGRENZTE ZEIT</h6>
                </div>
                <div v-if="awards" class="">
                  <p v-if="awards.length == 1">
                    Sie haben diese Auszeichnung am {{ formatDate(awards[0].awardedOn) }} erhalten.
                  </p>
                  <p v-else>
                    Sie haben diese Auszeichnung {{ awards.length }} Mal erhalten.
                  </p>
                </div>
              </div>
            </template>
            <template slot="footer">
               <md-button class="md-danger md-simple" style="align: center" @click="receivedModalHide">Close</md-button>
            </template>
          </modal>
    </div>
    <br />

    <div class="md-layout">
        <h4 class="md-layout-item md-size-100" style="text-align: left">Verfügbar</h4>
        <br />
        <div v-for="badge in available" :key="badge.id" class="md-layout-item md-medium-size-33 md-small-size-50 md-size-33">
          <div @click="onAvailbleBadgeClicked(badge)" class="badge">
            <div class="icon available-badge">
              <img :src="badge.icon" />
            </div>
            <p>{{ badge.name }}</p>
          </div>
      </div>
      <modal v-if="showAvailableModal" :id="availableBadge._id" class="modal fade">
            <template slot="header">
              <span class="h3">Auszeichung</span>
            </template>
            <template slot="body">
              <div class="modal-content">
                <div class="available-modal-icon">
                  <img :src="availableBadge.icon" />
                </div>
                <h2 class="title">{{ availableBadge.name }}</h2>
                <h3 class="h5" v-if="availableBadge.subtitle">{{ availableBadge.subtitle }}</h3>
                <p>{{ availableBadge.points}} Punkte - {{ availableBadge.challenge || availableBadge.description }}</p>
                <p v-if="availableBadge.challenge && availableBadge.description">{{ availableBadge.description }}</p>
                <blockquote v-if="availableBadge.explanation">
                  <p>Erklärung: {{ availableBadge.explanation }}</p>
                </blockquote>
                <p slot="date" class="date" v-if="availableBadge.activeFrom">
                  {{ formatDate(availableBadge.activeFrom, false) }} bis {{ formatDate(availableBadge.activeUntil, false) }}
                </p>
                <div v-if="availableBadge.activeFrom" class="limited-tag">
                  <h6 class="limited-text">BEGRENZTE ZEIT</h6>
                </div>
              </div>
            </template>
            <template slot="footer">
               <md-button class="md-danger md-simple" style="align: center" @click="availableModalHide">Close</md-button>
            </template>
      </modal>
    </div>
  </div>

</template>

<script>
import {Modal} from '@/components';
import datetime from "@/utils/datetime";

export default {
  name: "badges-list",
  components: {
    Modal
  },
  data() {
    return {
      my: [],
      available: [],
      showReceivedModal: false,
      receivedBadge: {},
      awards: [],
      showAvailableModal: false,
      selectedAvailableBadge: "",
      availableBadge: {},
    }
  },
  methods: {
    ...datetime,
    onReceivedBadgeClicked(badge) {
      this.showReceivedModal = true;
      this.receivedBadge = badge;
      this.awards = this.receivedBadge.award;
    },
    receivedModalHide() {
      this.showReceivedModal = false;
    },
    onAvailbleBadgeClicked(badge) {
      this.showAvailableModal = true;
      this.availableBadge = badge;
    },
    availableModalHide() {
      this.showAvailableModal = false;
    }
  },
  mounted() {
    this.$store.dispatch("queryAPI", {url: "/rest/badge?view=my"})
    .then(res => {
      this.my = res;
    })
    .catch(err => {
      this.$notify({
        timeout: 5000,
        message: err.message,
        icon: "add_alert",
        horizontalAlign: "right",
        verticalAlign: "top",
        type: "error"
      });
    });
    this.$store.dispatch("queryAPI", {url: "/rest/badge?view=available"})
    .then(res => {
      this.available = res;
    })
    .catch(err => {
      this.$notify({
        timeout: 5000,
        message: err.message,
        icon: "add_alert",
        horizontalAlign: "right",
        verticalAlign: "top",
        type: "error"
      });
    });
  }
}
</script>

<style>

.badge {
  color: black;
  padding: 5px;
}
.badge > .icon {
  width: 60px;
  height: 60px;
  overflow: hidden;
  transition: all 0.2s;
  -webkit-transition: all 0.2s;
  display: inline-block;
  max-width: 60px;
  max-height: 60px;
}
.badge > .icon > img {
  height: auto;
  width: auto;
  max-height: 100%;
  max-width: 100%;
}

.available-badge {
  filter: grayscale(1);
}

.received-modal-icon {
  margin-bottom: 10px;
  width: 150px;
  height: 150px;
  display: inline-block;
}
.modal-content {
  overflow-y: auto;
  max-height: 600px;
}
.available-modal-icon {
  filter: grayscale(1);
  margin-bottom: 10px;
  width: 150px;
  height: 150px;
  display: inline-block;
}

.limited-tag {
  background-color: grey;
  border-radius: 5px;
  display: inline-block;
  height: fit-content;
}

.limited-text {
  height: 25px;
  margin: auto;
  align-self: center;
  padding-top: 5px;
  padding-left: 10px;
  padding-right: 10px;
  color: white;
}

@media (max-height: 800px) {
  .modal-content {
    max-height: 400px;
  }
}

@media (max-height: 700px) {
  .modal-content {
    max-height: 300px;
  }
}

</style>
